import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useDeviceMetrics = () => {
  const { deviceMetrics, setDeviceMetrics, areDeviceMetricsLoaded, setAreDeviceMetricsLoaded } = useStoreContext()

  useEffect(() => {
    if (areDeviceMetricsLoaded) {
      return
    }

    setDeviceMetrics(null)
    setAreDeviceMetricsLoaded(false)

    Api.DeviceMetrics.list()
      .then(res => {
        setDeviceMetrics(res)
      })
      .catch(() => {
        setDeviceMetrics(null)
        setAreDeviceMetricsLoaded(true)
      })
      .finally(() => {
        setAreDeviceMetricsLoaded(true)
      })
  }, [areDeviceMetricsLoaded, setDeviceMetrics, setAreDeviceMetricsLoaded])

  return { deviceMetrics, areDeviceMetricsLoaded }
}

export default useDeviceMetrics
